import { Liquid as LiquidJs } from 'liquidjs';

/**
 * Renders the specified Liquid template using the provided scope and filters.
 *
 * @param template the Liquid template to render
 * @param scope the scope to provide to the template
 * @param filters the filters to provide to the template
 */
export const liquid = (template, scope, filters) => {
  const engine = new LiquidJs();
  // register the filters if there are any
  Object.entries(filters || {}).forEach(([name, filter]) => engine.registerFilter(name, filter));
  try {
    // parse and render the template synchronously
    return engine.parseAndRenderSync(template, scope);
  } catch (error) {
    console.error('Error in Liquid template', template, scope, error);
    return '';
  }
};
